// ContactList.js
import React, { useEffect, useState } from 'react';
import { Table, Spin } from 'antd';
import moment from 'moment';
import ProjectServices from '../../../../services/projectServices';
import { getTranslation } from '../../../../util/utilFunc';
import { useSelector } from 'react-redux';

const ContactList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ProjectServices.getContactData();
        setData(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const renderDescription = (text) => {
    const maxLength = 50;
    if (!text) {
      return "---"
    }
    return text?.length <= maxLength ? text : `${text?.slice(0, maxLength)}...`;
  };

  const { language } = useSelector(state => state.auth);


  // Define the columns for the Ant Design Table
  const columns = [
    {
      title: getTranslation('Full Name', language),
      dataIndex: 'full_name',
      key: 'full_name',
    },
    {
      title: getTranslation('Email', language),
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: getTranslation('Phone Number', language),
      dataIndex: 'phone_number',
      key: 'phone_number',
    },
    {
      title: getTranslation('Reason for Contacting', language),
      dataIndex: 'reason_for_contacting',
      key: 'reason_for_contacting',
    },
    {
      title: getTranslation('Message', language),
      dataIndex: 'message',
      render: renderDescription,
    },
    {
      title: getTranslation('Submitted At', language),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), // Format the date
    },
  ];

  if (loading) {
    return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;
  }

  return (
    <div style={{ padding: '20px' }}>
      <Table
        dataSource={data}
        columns={columns}
        rowKey={(record) => record.email}
        pagination={{ pageSize: 5 }}
        expandable={{
          expandedRowRender: record => <p style={{ margin: 0 }}>{record.message}</p>,
          rowExpandable: record => !!record.message,
        }}
      />
    </div>
  );
};

export default ContactList;
